import React from 'react';

import {
  Chip,
  Typography,
} from '@mui/material';

import {
  GridColDef,
} from '@mui/x-data-grid';

import {FDataGrid} from '../grid';

type Props={
  rows:any[];
  loading?:boolean;
  onTaskSelect:(row:any|null)=>void;
  selectedTaskId?:any;
};

export default class TaskGridPanel
extends React.PureComponent<Props>{

  private getRowId=(row:any)=>
    row.taskplanid
    ??row.rid
    ??row.id;

  private columns=():GridColDef[]=>[
    {
      field:'code',
      headerName:'Task Code',
      width:160,
      cellClassName:'task-cell-master',
    },
    {
      field:'name',
      headerName:'Task',
      minWidth:280,
      flex:1,
      cellClassName:'task-cell-master',
    },
    {
      field:'weight',
      headerName:'Weight',
      width:110,
      type:'number',
      cellClassName:'task-cell-governed',
    },
    {
      field:'budgetlinecount',
      headerName:'Budget Lines',
      width:120,
      type:'number',
      cellClassName:'task-cell-computed',
    },
    {
      field:'plannedamount',
      headerName:'Task Amount',
      width:160,
      type:'number',
      cellClassName:'task-cell-computed',
    },
    {
      field:'budgetstate',
      headerName:'Budget',
      width:110,
      renderCell:params=>(
        <Chip
          size="small"
          color={Number(params.value)===1?'success':'default'}
          label={Number(params.value)===1?'Budgeted':'No Budget'}
        />
      ),
      cellClassName:'task-cell-computed',
    },
    {
      field:'status',
      headerName:'State',
      width:120,
      cellClassName:'task-cell-governed',
    },
    {
      field:'description',
      headerName:'Description',
      minWidth:260,
      flex:1,
      renderCell:params=>(
        <Typography variant="body2">
          {params.value}
        </Typography>
      ),
      cellClassName:'task-cell-master',
    },
  ];

  render(){
    return (
      <FDataGrid
        title="Tasks"
        subtitle="Reusable Tasks are instantiated automatically with the Activity. Select a Task to prepare its budget lines."
        rows={this.props.rows||[]}
        columns={this.columns()}
        loading={this.props.loading}
        height={350}
        getRowId={this.getRowId}
        selectionMode="single"
        selectedRowId={this.props.selectedTaskId}
        onSelectedRowChange={row=>
          this.props.onTaskSelect(row)
        }
        getRowClassName={params=>
          String(this.getRowId(params.row))
          ===String(this.props.selectedTaskId??'')
            ?'task-row-selected'
            :''
        }
        sx={{
          '& .task-cell-master':{
            bgcolor:'info.lighter',
          },
          '& .task-cell-computed':{
            bgcolor:'success.lighter',
            fontWeight:600,
          },
          '& .task-cell-governed':{
            bgcolor:'action.hover',
          },
          '& .task-row-selected':{
            boxShadow:'inset 4px 0 0 0',
            boxShadowColor:'primary.main',
          },
        }}
      />
    );
  }
}
